(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(7)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * An event called when the user interacts with the map.
 *
 * @version 1.0.0
 * @since 2.0.0
 * @author [Ramiro Rojo](https://github.com/holywyvern)
 */var IsometricMapEvent=/**
   * Creates a new event
   * @param {*} target The selected element
   * @param {number} x The x position of the element selected
   * @param {number} y The y position of the element selected
   * @param {string} type The type of event, "click", "enter" or "leave"
   * @param {string} area The area clicked "floor", "left-wall", "right-wall", "map"
   */function IsometricMapEvent(target,x,y,type,area){_classCallCheck(this,IsometricMapEvent);this.target=target;this.x=x;this.y=y;this.type=type;this.area=area;};/* harmony default export */ __webpack_exports__["a"] = (IsometricMapEvent);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * An animated texture is an image than changes frames on a regular interval
 * It's similar to a gif, but it's using a set of frames as different images.
 *
 * @version 1.0.0
 * @since 1.0.0
 * @author [Ramiro Rojo](https://github.com/holywyvern)
 */var AnimatedTexture=function(_Component){_inherits(AnimatedTexture,_Component);function AnimatedTexture(props){var context=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;_classCallCheck(this,AnimatedTexture);var _this=_possibleConstructorReturn(this,(AnimatedTexture.__proto__||Object.getPrototypeOf(AnimatedTexture)).call(this,props,context));_initialiseProps.call(_this);var delay=_this.props.delay;_this.state={currentFrame:0,currentDelay:delay};return _this;}_createClass(AnimatedTexture,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.delay===this.props.delay){return;}if(nextProps.frames.length!==this.props.frames){return this.setupAnimation(nextProps);}for(var i=0;i<nextProps.frames.length;++i){if(nextProps.frames[i]!==this.props.frames[i]){return this.setupAnimation(nextProps);}}}},{key:'componentDidMount',value:function componentDidMount(){this.__ticker=null;// @ts-ignore
this.setupTicker(this.props);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.removeTicker();}},{key:'setupAnimation',value:function setupAnimation(_ref){var delay=_ref.delay,frames=_ref.frames;this.setupTicker({delay:delay,frames:frames});this.setState({currentFrame:0,currentDelay:delay});}},{key:'removeTicker',value:function removeTicker(){if(this.__ticker!==null){this.__ticker.detach();this.__ticker=null;}}},{key:'setupTicker',value:function setupTicker(_ref2){var delay=_ref2.delay,frames=_ref2.frames;this.removeTicker();if(delay>0&&frames.length>1){var ticker=this.context.ticker;this.__ticker=ticker.add(this.onFrameUpdate);}}},{key:'render',value:function render(){var _props=this.props,frames=_props.frames,contentOnTop=_props.contentOnTop,props=_objectWithoutProperties(_props,['frames','contentOnTop']);var currentFrame=this.state.currentFrame;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,contentOnTop&&contentOnTop(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',Object.assign({},props,{key:'img',onClick:this.onClick,src:frames[currentFrame],alt:''})));}}]);return AnimatedTexture;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AnimatedTexture.propTypes={/** Array of images the animated texture uses */frames:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,/** The interval on wich each frame is changed, in milliseconds */delay:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** A set of extra classes added into the component */className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/** CSS style, same as any component */style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,/** Callback for action when clicked */onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,contentOnTop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};AnimatedTexture.contextTypes={ticker:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var _initialiseProps=function _initialiseProps(){var _this2=this;this.onFrameUpdate=function(delta){var _props2=_this2.props,delay=_props2.delay,frames=_props2.frames;var _state=_this2.state,currentFrame=_state.currentFrame,currentDelay=_state.currentDelay;currentDelay-=delta;while(currentDelay<=0){currentDelay+=delay;currentFrame+=1;}currentFrame=currentFrame%frames.length;_this2.setState({currentFrame:currentFrame,currentDelay:currentDelay});};this.onClick=function(){var onClick=_this2.props.onClick;if(typeof onClick==='function'){onClick();}};};/* harmony default export */ __webpack_exports__["a"] = (AnimatedTexture);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_IsometricMap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_IsometricTile__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IsometricObject__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AnimatedTexture__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnimatedTexture", function() { return __WEBPACK_IMPORTED_MODULE_4__components_AnimatedTexture__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IsometricMap", function() { return __WEBPACK_IMPORTED_MODULE_0__components_IsometricMap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IsometricTile", function() { return __WEBPACK_IMPORTED_MODULE_1__components_IsometricTile__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IsometricObject", function() { return __WEBPACK_IMPORTED_MODULE_2__components_IsometricObject__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IsometricMapEvent", function() { return __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a"]; });
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_IsometricMap__["a" /* default */]);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mini_signals__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mini_signals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mini_signals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IsometricMap_scss__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IsometricMap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__IsometricMap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_IsometricMapEvent__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * An isometric map is a container for isometric objects and isometric tiles.
 * It provides basic functionallity
 *
 * @version 1.0.0
 * @since 1.0.0
 * @author [Ramiro Rojo](https://github.com/holywyvern)
 */var IsometricMap=function(_Component){_inherits(IsometricMap,_Component);function IsometricMap(props){_classCallCheck(this,IsometricMap);var _this=_possibleConstructorReturn(this,(IsometricMap.__proto__||Object.getPrototypeOf(IsometricMap)).call(this,props));_this.onFrameUpdate=function(delta){if(!_this.__isMounted)return;__WEBPACK_IMPORTED_MODULE_3_raf___default()(_this.onFrameUpdate);var now=Date.now();_this.ticker.dispatch(now-_this.__lastUpdate);_this.__lastUpdate=now;};_this.onMouseDown=function(e){if(e.button===0){var _this$props=_this.props,onMouseDown=_this$props.onMouseDown,onMouseAction=_this$props.onMouseAction;var event=new __WEBPACK_IMPORTED_MODULE_5__events_IsometricMapEvent__["a" /* default */](_this,-1,-1,"down","map");if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onMouseDown==="function"){onMouseDown(event);}}};_this.onMouseUp=function(e){if(e.button===0){var _this$props2=_this.props,onMouseUp=_this$props2.onMouseUp,onMouseAction=_this$props2.onMouseAction;var event=new __WEBPACK_IMPORTED_MODULE_5__events_IsometricMapEvent__["a" /* default */](_this,-1,-1,"up","map");if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onMouseUp==="function"){onMouseUp(event);}}};_this.onMouseEnter=function(e){if(e.button===0){var _this$props3=_this.props,onMouseEnter=_this$props3.onMouseEnter,onMouseAction=_this$props3.onMouseAction;var event=new __WEBPACK_IMPORTED_MODULE_5__events_IsometricMapEvent__["a" /* default */](_this,-1,-1,"enter","map");if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onMouseEnter==="function"){onMouseEnter(event);}}};_this.onMouseLeave=function(e){if(e.button===0){var _this$props4=_this.props,onMouseLeave=_this$props4.onMouseLeave,onMouseAction=_this$props4.onMouseAction;var event=new __WEBPACK_IMPORTED_MODULE_5__events_IsometricMapEvent__["a" /* default */](_this,-1,-1,"leave","map");if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onMouseLeave==="function"){onMouseLeave(event);}}};_this.ticker=new __WEBPACK_IMPORTED_MODULE_2_mini_signals___default.a();return _this;}_createClass(IsometricMap,[{key:"componentDidMount",value:function componentDidMount(){this.__isMounted=true;this.__lastUpdate=Date.now();__WEBPACK_IMPORTED_MODULE_3_raf___default()(this.onFrameUpdate);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.__isMounted=false;}},{key:"getChildContext",value:function getChildContext(){return{ticker:this.ticker};}},{key:"render",value:function render(){var _props=this.props,children=_props.children,mapWidth=_props.mapWidth,mapHeight=_props.mapHeight,tileSize=_props.tileSize,slabSize=_props.slabSize,sizeUnit=_props.sizeUnit,margin=_props.margin,offsetY=_props.offsetY;var vars={"--map-width":mapWidth,"--map-height":mapHeight,"--tile-size":tileSize,"--slab-size":slabSize,"--size-unit":sizeUnit,"--margin-top":margin.top,"--margin-bottom":margin.bottom,"--margin-left":margin.left,"--margin-right":margin.right,"--map-max-dimension":Math.max(mapWidth,mapHeight),"--map-offset-y":offsetY};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-isometric-map-wrapper",style:vars,onMouseDown:this.onMouseDown,onMouseUp:this.onMouseUp,onMouseEnter:this.onMouseEnter,onMouseLeave:this.onMouseLeave},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-isometric-map"},children));}}]);return IsometricMap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IsometricMap.propTypes={/** The width of the map, in tiles */mapWidth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The height of the map, in tiles */mapHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/**
     * The size of the tile. It represents the width of the horizontal diagonal
     * and double the size of the vertical diagonal */tileSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The size of a tile lifting per it's z height */slabSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** A CSS unit for dimensions, usually 1px */sizeUnit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/**
     * The margin of the tile, this margins are extra space drawed by the tiles than you
     * can use to apply some details into the tile, and make maps look less squared
     */margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({/** The top margin, used by the floor */top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The bottom margin, used by the floor and the bottom part of the wall  */bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The left margin, used by everything */left:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The right margin, used by everything */right:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}),/** An offset to move the map down, usefull to show the height properly */offsetY:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,/** Callback for users interacting with the map */onMouseAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when you press the mouse down */onMouseDown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when you press the mouse up */onMouseUp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse enters the map */onMouseEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse exists the map */onMouseLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};IsometricMap.defaultProps={sizeUnit:"1px",offsetY:0,margin:{top:0,left:0,right:0,bottom:0}};IsometricMap.childContextTypes={/** The ticker is an object than can handle events on frame update.
     * It calls when a new frame is triggered with request animation frame
     */ticker:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (IsometricMap);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(8);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var MiniSignalBinding = (function () {
  function MiniSignalBinding(fn, once, thisArg) {
    if (once === undefined) once = false;

    _classCallCheck(this, MiniSignalBinding);

    this._fn = fn;
    this._once = once;
    this._thisArg = thisArg;
    this._next = this._prev = this._owner = null;
  }

  _createClass(MiniSignalBinding, [{
    key: 'detach',
    value: function detach() {
      if (this._owner === null) return false;
      this._owner.detach(this);
      return true;
    }
  }]);

  return MiniSignalBinding;
})();

function _addMiniSignalBinding(self, node) {
  if (!self._head) {
    self._head = node;
    self._tail = node;
  } else {
    self._tail._next = node;
    node._prev = self._tail;
    self._tail = node;
  }

  node._owner = self;

  return node;
}

var MiniSignal = (function () {
  function MiniSignal() {
    _classCallCheck(this, MiniSignal);

    this._head = this._tail = undefined;
  }

  _createClass(MiniSignal, [{
    key: 'handlers',
    value: function handlers() {
      var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      var node = this._head;

      if (exists) return !!node;

      var ee = [];

      while (node) {
        ee.push(node);
        node = node._next;
      }

      return ee;
    }
  }, {
    key: 'has',
    value: function has(node) {
      if (!(node instanceof MiniSignalBinding)) {
        throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
      }

      return node._owner === this;
    }
  }, {
    key: 'dispatch',
    value: function dispatch() {
      var node = this._head;

      if (!node) return false;

      while (node) {
        if (node._once) this.detach(node);
        node._fn.apply(node._thisArg, arguments);
        node = node._next;
      }

      return true;
    }
  }, {
    key: 'add',
    value: function add(fn) {
      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      if (typeof fn !== 'function') {
        throw new Error('MiniSignal#add(): First arg must be a Function.');
      }
      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
    }
  }, {
    key: 'once',
    value: function once(fn) {
      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      if (typeof fn !== 'function') {
        throw new Error('MiniSignal#once(): First arg must be a Function.');
      }
      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
    }
  }, {
    key: 'detach',
    value: function detach(node) {
      if (!(node instanceof MiniSignalBinding)) {
        throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
      }
      if (node._owner !== this) return this;

      if (node._prev) node._prev._next = node._next;
      if (node._next) node._next._prev = node._prev;

      if (node === this._head) {
        this._head = node._next;
        if (node._next === null) {
          this._tail = null;
        }
      } else if (node === this._tail) {
        this._tail = node._prev;
        this._tail._next = null;
      }

      node._owner = null;
      return this;
    }
  }, {
    key: 'detachAll',
    value: function detachAll() {
      var node = this._head;
      if (!node) return this;

      this._head = this._tail = null;

      while (node) {
        node._owner = null;
        node = node._next;
      }
      return this;
    }
  }]);

  return MiniSignal;
})();

MiniSignal.MiniSignalBinding = MiniSignalBinding;

exports['default'] = MiniSignal;
module.exports = exports['default'];


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(12)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedTexture__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IsometricTile_scss__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IsometricTile_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__IsometricTile_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * A tile is a square on the map. It is composed of a floor and optionally
 * a right and a left walls.
 * The tiles are the floor of your map, so it can be grass, dirt or water, for example.
 *
 * @version 1.0.0
 * @since 1.0.0
 * @author [Ramiro Rojo](https://github.com/holywyvern)
 */var IsometricTile=function(_Component){_inherits(IsometricTile,_Component);function IsometricTile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IsometricTile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IsometricTile.__proto__||Object.getPrototypeOf(IsometricTile)).call.apply(_ref,[this].concat(args))),_this),_this.onFloorClick=function(e){var _this$props=_this.props,onMouseAction=_this$props.onMouseAction,onClick=_this$props.onClick,onFloorClick=_this$props.onFloorClick,x=_this$props.x,y=_this$props.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"click","floor");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onClick==="function"){onClick(event);}if(typeof onFloorClick==="function"){onFloorClick(event);}},_this.onLeftWallClick=function(e){var _this$props2=_this.props,onMouseAction=_this$props2.onMouseAction,onClick=_this$props2.onClick,onWallClick=_this$props2.onWallClick,onLeftWallClick=_this$props2.onLeftWallClick,x=_this$props2.x,y=_this$props2.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"click","left-wall");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onClick==="function"){onClick(event);}if(typeof onWallClick==="function"){onWallClick(event);}if(typeof onLeftWallClick==="function"){onLeftWallClick(event);}},_this.onRigthWallClick=function(e){var _this$props3=_this.props,onMouseAction=_this$props3.onMouseAction,onClick=_this$props3.onClick,onWallClick=_this$props3.onWallClick,onRigthWallClick=_this$props3.onRigthWallClick,x=_this$props3.x,y=_this$props3.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"click","right-wall");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onClick==="function"){onClick(event);}if(typeof onWallClick==="function"){onWallClick(event);}if(typeof onRigthWallClick==="function"){onRigthWallClick(event);}},_this.onFloorMouseEnter=function(e){var _this$props4=_this.props,onMouseAction=_this$props4.onMouseAction,onEnter=_this$props4.onEnter,onFloorEnter=_this$props4.onFloorEnter,x=_this$props4.x,y=_this$props4.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"enter","floor");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onEnter==="function"){onEnter(event);}if(typeof onFloorEnter==="function"){onFloorEnter(event);}},_this.onFloorMouseLeave=function(e){var _this$props5=_this.props,onMouseAction=_this$props5.onMouseAction,onLeave=_this$props5.onLeave,onFloorLeave=_this$props5.onFloorLeave,x=_this$props5.x,y=_this$props5.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"leave","floor");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onLeave==="function"){onLeave(event);}if(typeof onFloorLeave==="function"){onFloorLeave(event);}},_this.onLeftWallEnter=function(e){var _this$props6=_this.props,onMouseAction=_this$props6.onMouseAction,onEnter=_this$props6.onEnter,onWallEnter=_this$props6.onWallEnter,onLeftWallEnter=_this$props6.onLeftWallEnter,x=_this$props6.x,y=_this$props6.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"enter","left-wall");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onEnter==="function"){onEnter(event);}if(typeof onWallEnter==="function"){onWallEnter(event);}if(typeof onLeftWallEnter==="function"){onLeftWallEnter(event);}},_this.onLeftWallLeave=function(e){var _this$props7=_this.props,onMouseAction=_this$props7.onMouseAction,onLeave=_this$props7.onLeave,onWallLeave=_this$props7.onWallLeave,onLeftWallLeave=_this$props7.onLeftWallLeave,x=_this$props7.x,y=_this$props7.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"leave","left-wall");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onLeave==="function"){onLeave(event);}if(typeof onWallLeave==="function"){onWallLeave(event);}if(typeof onLeftWallLeave==="function"){onLeftWallLeave(event);}},_this.onRightWallEnter=function(e){var _this$props8=_this.props,onMouseAction=_this$props8.onMouseAction,onEnter=_this$props8.onEnter,onWallEnter=_this$props8.onWallEnter,onRightWallEnter=_this$props8.onRightWallEnter,x=_this$props8.x,y=_this$props8.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"enter","right-wall");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onEnter==="function"){onEnter(event);}if(typeof onWallEnter==="function"){onWallEnter(event);}if(typeof onRightWallEnter==="function"){onRightWallEnter(event);}},_this.onRightWallLeave=function(e){var _this$props9=_this.props,onMouseAction=_this$props9.onMouseAction,onLeave=_this$props9.onLeave,onWallLeave=_this$props9.onWallLeave,onRightWallLeave=_this$props9.onRightWallLeave,x=_this$props9.x,y=_this$props9.y;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,"leave","right-wall");e.stopPropagation();if(typeof onMouseAction==="function"){onMouseAction(event);}if(typeof onLeave==="function"){onLeave(event);}if(typeof onWallLeave==="function"){onWallLeave(event);}if(typeof onRightWallLeave==="function"){onRightWallLeave(event);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IsometricTile,[{key:"renderTopAndBottomWalls",value:function renderTopAndBottomWalls(mapper,height,prefix){var _props=this.props,frames=_props.frames,delay=_props.delay;if(!frames)return;var results=[];var textures=frames.map(mapper);if(height>0){results.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AnimatedTexture__["a" /* default */],{key:prefix+"-top",frames:textures.map(function(i){return i.top;}),delay:delay,className:"textures top "+prefix}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AnimatedTexture__["a" /* default */],{key:prefix+"-bottom",frames:textures.map(function(i){return i.bottom;}),delay:delay,className:"textures bottom "+prefix}));}return results;}},{key:"renderMiddleWalls",value:function renderMiddleWalls(mapper,height,prefix){var _props2=this.props,frames=_props2.frames,delay=_props2.delay;if(!frames)return;var textures=frames.map(mapper);var result=[];var h=height;for(var i=1;i<h;++i){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AnimatedTexture__["a" /* default */],{key:prefix+"-middle-wall-"+i,frames:textures,delay:delay,className:"textures middle "+prefix,style:{"--wall-index":i}}));}return result;}},{key:"render",value:function render(){var _props3=this.props,x=_props3.x,y=_props3.y,z=_props3.z,leftZ=_props3.leftZ,rightZ=_props3.rightZ,className=_props3.className,frames=_props3.frames,delay=_props3.delay,style=_props3.style;var lz=leftZ===null?z:leftZ;var rz=rightZ===null?z:rightZ;var vars=Object.assign({},style||{},{"--x":x,"--y":y,"--z":z,"--left-z":lz,"--right-z":rz});var classes=["react-isometric-tile"];if(className)classes.push(className);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.join(" "),style:vars},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floor",onClick:this.onFloorClick,onMouseEnter:this.onFloorMouseEnter,onMouseLeave:this.onFloorMouseLeave}),lz>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"wall left",onClick:this.onLeftWallClick,onMouseEnter:this.onLeftWallEnter,onMouseLeave:this.onLeftWallLeave}):null,rz>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"wall right",onClick:this.onRigthWallClick,onMouseEnter:this.onRightWallEnter,onMouseLeave:this.onRightWallLeave}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"textures-group"},this.renderMiddleWalls(function(i){return i.rightWall.middle;},lz,"right"),this.renderMiddleWalls(function(i){return i.leftWall.middle;},rz,"left"),this.renderTopAndBottomWalls(function(i){return i.leftWall;},lz,"left"),this.renderTopAndBottomWalls(function(i){return i.rightWall;},rz,"right"),frames?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AnimatedTexture__["a" /* default */],{frames:frames.map(function(i){return i.floor;}),delay:delay,className:"textures floor"}):null));}}]);return IsometricTile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IsometricTile.propTypes={/** The x position of the tile, from 0 to width - 1 */x:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The y position of the tile, from 0 to height - 1 */y:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The height of the tile, it will be "lifted" as map slab size * z */z:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,/** The height of the left wall, by default it is the same as the z value */leftZ:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,null]),/* The height of the right wall, by default it is the same as the z value */rightZ:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,null]),/** A list of frames for each part of the tile */frames:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({/** The floor texture name */floor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,/** The left wall textures */leftWall:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({/** The top part of the wall */top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,/** The middle part of the texture (repeats vertically) */middle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,/** The bottom part of the texture */bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,/** The right wall textures */rightWall:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({/** The top part of the wall */top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,/** The middle part of the texture (repeats vertically) */middle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,/** The bottom part of the texture */bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired})),/** An intervall in milliseconds on wich each frame changes */delay:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,/** Extra css classes added into the object */className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/** An style object of CSS propertyes */style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,/** Event used to catch all mouse events */onMouseAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Click event for the entire tile */onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Click event for only the floor */onFloorClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Click event for any wall */onWallClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Click event for left wall */onLeftWallClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Click event for right wall */onRigthWallClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse enters any part of the tile */onEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse enters the floor of the tile */onFloorEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse enters any wall of the tile */onWallEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse enters the left wall of the tile */onLeftWallEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse enters the right of the tile */onRigthWallEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse exits any part of the tile */onLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse exits the floor of the tile */onFloorLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse exits any wall of the tile */onWallLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse exits the left wall of the tile */onLeftWallLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback called when the mouse exits the right of the tile */onRigthWallLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};IsometricTile.defaultProps={z:0,leftZ:null,rightZ:null,delay:0};/* harmony default export */ __webpack_exports__["a"] = (IsometricTile);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedTexture__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IsometricObject_scss__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IsometricObject_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__IsometricObject_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * An isometric object is everything than is not  a tile or a character.
 * They can be animated and over any tile.
 * They are used for decorations than don't look like a floor pice, like trees, rocks
 * or buildings.
 *
 * @version 1.0.0
 * @since 1.0.0
 * @author [Ramiro Rojo](https://github.com/holywyvern)
 */var IsometricObject=function(_Component){_inherits(IsometricObject,_Component);function IsometricObject(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IsometricObject);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IsometricObject.__proto__||Object.getPrototypeOf(IsometricObject)).call.apply(_ref,[this].concat(args))),_this),_this.onClick=function(e){var _this$props=_this.props,x=_this$props.x,y=_this$props.y,onClick=_this$props.onClick,onMouseAction=_this$props.onMouseAction,active=_this$props.active;if(!active)return;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,'click','object');e.stopPropagation();if(typeof onMouseAction==='function'){onMouseAction(event);}if(typeof onClick==='function'){onClick(event);}},_this.onMouseEnter=function(e){var _this$props2=_this.props,x=_this$props2.x,y=_this$props2.y,onEnter=_this$props2.onEnter,onMouseAction=_this$props2.onMouseAction,active=_this$props2.active;if(!active)return;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,'enter','object');e.stopPropagation();if(typeof onMouseAction==='function'){onMouseAction(event);}if(typeof onEnter==='function'){onEnter(event);}},_this.onMouseLeave=function(e){var _this$props3=_this.props,x=_this$props3.x,y=_this$props3.y,onLeave=_this$props3.onLeave,onMouseAction=_this$props3.onMouseAction,active=_this$props3.active;if(!active)return;var event=new __WEBPACK_IMPORTED_MODULE_3__events_IsometricMapEvent__["a" /* default */](_this,x,y,'leave','object');e.stopPropagation();if(typeof onMouseAction==='function'){onMouseAction(event);}if(typeof onLeave==='function'){onLeave(event);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IsometricObject,[{key:'render',value:function render(){var _props=this.props,x=_props.x,y=_props.y,z=_props.z,width=_props.width,height=_props.height,active=_props.active,className=_props.className,style=_props.style,frames=_props.frames,delay=_props.delay,contentOnTop=_props.contentOnTop;var vars=Object.assign({},style||{},{'--x':x,'--y':y,'--z':z,'--object-width':width,'--object-height':height});var classes=['react-isometric-object-wrapper'];if(className)classes.push(className);if(active){classes.push('active');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.join(' '),style:vars},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'react-isometric-object',onClick:this.onClick},frames?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AnimatedTexture__["a" /* default */],{frames:frames,delay:delay,contentOnTop:contentOnTop}):null));}}]);return IsometricObject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IsometricObject.propTypes={/** The x position of the map (from 0 to map width - 1) */x:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The y position of the map (from 0 to map height - 1) */y:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The width of the object */width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The height of the object */height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/** The height of the object it will be lifted off the ground as z * map slab size */z:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,/** If the object is active, it will catch events, also have less transparency */active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,/** Extra css classes you want to add into the object */className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/** extra style you wish to apply into te object */style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,/** A list of strings, each string having an uri of each frame */frames:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),/** An interval between each frame */delay:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,/** An even triggered when the user clicks on the object */onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** An event triggered when the user moves the mouse over the object */onEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** An event triggered when the user moves the mouse out of the object */onLeave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Callback for any mouse event */onMouseAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,contentOnTop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};IsometricObject.defaultProps={z:0,delay:0,active:false};/* harmony default export */ __webpack_exports__["a"] = (IsometricObject);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js